<template>
  <ConfirmationAlert />
  <NotificationToast />
  <ErrorAlertComponent />
  <TermsComponent />
  <OffcanvasViews />
  <!-- a Pamia é só para quem está logado -->
  <PamiaWidget v-if="session" />
  <router-view />
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted } from "vue";
import { storeToRefs } from "pinia";
import ErrorAlertComponent from "@/components/ErrorAlertComponent.vue";
import NotificationToast from "@/components/NotificationToast.vue";
import TermsComponent from "@/components/TermsComponent.vue";
import { pusherService } from "@/di/pusher";
import { syncSession } from "@/di/useCases";
import { useOffcanvasStore } from "@/store/useOffcanvasStore";
import { useSessionStore } from "@/store/useSessionStore";
import { toggleOffcanvas } from "@/utils/Helper";
import OffcanvasViews from "@/views/OffcanvasViews/OffcanvasViews.vue";
import { startFirebase } from "./firebaseinit";

document.title = process.env.VUE_APP_APP_NAME as string;
const { session } = storeToRefs(useSessionStore());

onMounted(() => {
  // reabre o painel lateral que estava aberto antes do reload
  if (useOffcanvasStore().config?.path) toggleOffcanvas("offcanvas_views");
  if (useSessionStore().session) syncSession.execute();
  pusherService.connect();
  startFirebase();
});
onBeforeUnmount(() => pusherService.disconnect());
</script>

<style scoped>
body {
  background-color: #fff !important;
}
</style>
